var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"max-w-3xl mx-auto py-5"},[_c('alert',{staticClass:"px-5",attrs:{"level":"warning","message":_vm.$store.state.app.i18n.errors[404]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }